import store from 'store';
import { makeRequest } from 'utils/requestLogger';

export default (payload) => {
  const p = makeRequest('put', `/api/users/${payload.id}/email`, payload);

  return p.then((resp) => {
    // dispatch event with the new email
    store.dispatch('changeEmail', payload.new_email);
    return resp;
  });
};



// WEBPACK FOOTER //
// ./src/app/services/account/changeEmail.js